import React from 'react';

import { SearchPopoverProps } from 'ui/SearchPopover/types';

import {
  DeviceTypeContent,
  DeviceTypeIDText,
  DeviceTypeNameText,
} from 'containers/Devices/components/DeviceTypeCell/styles';

import Chip from 'components/Chip';

import { colors } from 'theme/colors';

const DropDownItem: SearchPopoverProps['ListItem'] = ({ item, onClick }) => (
  <Chip
    id={`device-${item.uuid}`}
    key={item.uuid}
    label={
      <DeviceTypeContent>
        <DeviceTypeNameText id={`device-brand-${item.brand}`}>{`${item.brand} ${item.model}`}</DeviceTypeNameText>
        <DeviceTypeIDText id={`device-name-${item.name}`}>({item.name})</DeviceTypeIDText>
      </DeviceTypeContent>
    }
    iconLeft={<img src={item.image} alt={`${item.brand} ${item.model}`} />}
    onClick={() => {
      onClick?.(item);
    }}
    size="small"
    colors={{
      background: colors.common.white,
    }}
  />
);

export default DropDownItem;
